import { useTranslation } from 'react-i18next'

import { IUserMessage } from '../../../../types/conversations'
import { msToHour } from '../../../../utils/time'
import Metadata from '../Metadata/Metadata'

import styles from './user-message.module.scss'

interface IUserMessageProps {
    message: IUserMessage
}

function UserMessage(props: IUserMessageProps) {
    const { t } = useTranslation()

    const { message } = props

    const renderUserMessage = (text: string) => {
        if (text.startsWith('/')) {
            return (
                <>
                    <span className={styles.userMessage__action}>
                        {`${t('action')}: `}
                    </span>
                    {text.substring(1)}
                </>
            )
        }

        return text
    }

    return (
        <div className={styles.userMessage__wrapper}>
            <div className={styles.userMessage}>
                {renderUserMessage(message.parse_data.text)}
                <Metadata
                    className={styles.userMessage__metadata}
                    date={message.timestamp}
                    intent={message.parse_data.intent}
                />
            </div>
            <div className={styles.userMessage__hour}>
                {msToHour(message.timestamp)}
            </div>
        </div>
    )
}

export default UserMessage
